import WebServices from '../WebServices';
import { showSnackBarMessage } from './AppInfoActions';
import {
    ACTIONS_FETCH, ACTIONS_FETCH_ERROR, ACTIONS_FETCH_SUCCESS, ACTIONS_SUBMIT, ACTIONS_SUBMIT_ERROR, ACTIONS_SUBMIT_SUCCESS,
    ACTIONS_ONE_TIME_DEVIATION, ACTIONS_ONE_TIME_DEVIATION_SUCCESS, ACTIONS_ONE_TIME_DEVIATION_ERROR, ACTIONS_UPDATE_APPROVED,
    ACTIONS_SELECT_PROJECT, ACTIONS_SELECT_PROJECT_FUNCTION, ACTIONS_SET_PENDING_STEP_INDEX,
    ACTIONS_SET_PENDING_SORT_PROPERTY, ACTIONS_SET_APPROVED_SORT_PROPERTY,
    ACTION_CHANGE_COMPLIANCE, ACTION_CHANGE_COMPLIANCE_SUCCESS, ACTION_CHANGE_COMPLIANCE_ERROR,
    ACTIONS_SUBMIT_PENDING, ACTIONS_SUBMIT_PENDING_ERROR, ACTIONS_SUBMIT_PENDING_SUCCESS,
    ACTIONS_FETCH_PROJECT_FUNCTIONS, ACTIONS_FETCH_PROJECT_FUNCTIONS_ERROR, ACTIONS_FETCH_PROJECT_FUNCTIONS_SUCCESS,
    ACTIONS_UPLOAD_DEVIATION_FILES, ACTIONS_UPLOAD_DEVIATION_FILES_ERROR, ACTIONS_UPLOAD_DEVIATION_SUCCESS, ACTIONS_DELETE_DEVIATION_FILE,
    ACTIONS_DELETE_DEVIATION_FILE_ERROR, ACTIONS_DELETE_DEVIATION_FILE_SUCCESS, ACTIONS_FETCH_PROJECT_FUNCTION_DETAILS,
    ACTIONS_FETCH_PROJECT_FUNCTION_DETAILS_SUCCESS, ACTIONS_FETCH_PROJECT_FUNCTION_DETAILS_ERROR, ACTION_UPDATE, ACTION_UPDATE_ERROR,
    ACTION_UPDATE_SUCCESS, ACTION_UPDATE_ALL, ACTION_UPDATE_ALL_ERROR, ACTION_UPDATE_ALL_SUCCESS, ACTIONS_PROCEDURE_COMMENT_SAVE, ACTIONS_PROCEDURE_COMMENT_SAVE_SUCCESS, ACTIONS_PROCEDURE_COMMENT_SAVE_ERROR
} from './Types';
import { createDispatchHook } from 'react-redux';


const setPendingSortProperty = sortProperty => ({ type: ACTIONS_SET_PENDING_SORT_PROPERTY, payload: sortProperty });
const setApprovedSortProperty = sortProperty => ({ type: ACTIONS_SET_APPROVED_SORT_PROPERTY, payload: sortProperty });

const fetchProjectFunctions = () => async (dispatch, getState) => {

    let webServices = new WebServices();
    dispatch({ type: ACTIONS_FETCH_PROJECT_FUNCTIONS });


    try {

        const projectFunctions = await webServices.getMyProjectFunctions();
        dispatch({ type: ACTIONS_FETCH_PROJECT_FUNCTIONS_SUCCESS, payload: projectFunctions });

    } catch (error) {
        console.log(error);
        dispatch({ type: ACTIONS_FETCH_PROJECT_FUNCTIONS_ERROR, payload: error });
    }

}

const changeCompliance = action => async (dispatch, getState) => {

    let webServices = new WebServices();
    dispatch({ type: ACTION_CHANGE_COMPLIANCE });
    const projectId = getState().actions.selectedProject.id;
    const functionId = getState().actions.selectedProject.selectedFunction.id;

    try {


        const updatedAction = await webServices.updateAction(action);
        const projectFunctionDetails = await webServices.actiontsProjectFunctionDetails({ projectId, functionId });
        dispatch({ type: ACTION_CHANGE_COMPLIANCE_SUCCESS, payload: projectFunctionDetails });
        dispatch(showSnackBarMessage(`Compliance Change Succesfull`));



    } catch (error) {
        dispatch({ type: ACTION_CHANGE_COMPLIANCE_ERROR, payload: error });
        dispatch(showSnackBarMessage(`Compliance Change Error`));

    }

}


const fetchProjectFunctionDetails = ({ projectId, functionId }) => async (dispatch) => {

    let webServices = new WebServices();
    dispatch({ type: ACTIONS_FETCH_PROJECT_FUNCTION_DETAILS });


    try {

        const projectFunctionDetails = await webServices.actiontsProjectFunctionDetails({ projectId, functionId });
        dispatch({ type: ACTIONS_FETCH_PROJECT_FUNCTION_DETAILS_SUCCESS, payload: projectFunctionDetails });


    } catch (error) {
        console.log(error);
        dispatch({ type: ACTIONS_FETCH_PROJECT_FUNCTION_DETAILS_ERROR, payload: error });
    }

}


const fetchActions = () => async (dispatch) => {

    let webServices = new WebServices();
    dispatch({ type: ACTIONS_FETCH });


    try {

        const actions = await webServices.getActions();
        dispatch({ type: ACTIONS_FETCH_SUCCESS, payload: actions });


    } catch (error) {
        console.log(error);
        dispatch({ type: ACTIONS_FETCH_ERROR, payload: error });
    }

}

const selectProject = project => (dispatch, getState) => {
    const actionsState = getState().actions;
    const mineProjects = actionsState.projectFunctionsMine || [];
    const allProjects = actionsState.projectFunctions || [];
    const approvalRoles = (getState().app.aboutCurrentUser && getState().app.aboutCurrentUser.approvalRoles) || [];
    const normalize = (value) => (value || '').toString().trim().toLowerCase();

    let selectedProject = null;
    if (project && project.id) {
        // First look in assigned projects, then fall back to all projects (allows admin to select any project)
        selectedProject = mineProjects.find((item) => item && item.id === project.id)
            || allProjects.find((item) => item && item.id === project.id)
            || project
            || null;
    }

    if (!selectedProject && mineProjects.length > 0) {
        selectedProject = mineProjects[0];
    }

    dispatch({ type: ACTIONS_SELECT_PROJECT, payload: selectedProject });

    if (selectedProject && selectedProject.functions && selectedProject.functions.length > 0) {
        const projectNames = [
            normalize(selectedProject.name),
            normalize(selectedProject.preferredName),
        ].filter(Boolean);

        // Prefer a project-specific approver role, then fall back to generic approver roles.
        const projectSpecificRole = approvalRoles.find((role) => {
            if (!role || !role.function) {
                return false;
            }

            const roleProject = normalize(role.project);
            return !!roleProject && projectNames.includes(roleProject);
        });

        const fallbackRole = approvalRoles.find((role) => role && role.function);
        const approverRole = projectSpecificRole || fallbackRole;

        const approverFunction = approverRole
            ? selectedProject.functions.find((f) => normalize(f.name) === normalize(approverRole.function))
            : null;

        dispatch(selectProjectFunction(approverFunction || selectedProject.functions[0]));
    }
}

const selectProjectFunction = aFunction => async (dispatch, getState) => {

    const selectedProject = getState().actions.selectedProject;
    if (!selectedProject || !selectedProject.id || !aFunction || !aFunction.id) {
        return;
    }

    const selectedFunction = (selectedProject.functions || []).find((item) => item && item.id === aFunction.id);
    if (!selectedFunction) {
        return;
    }

    const projectId = selectedProject.id;

    dispatch({ type: ACTIONS_SELECT_PROJECT_FUNCTION, payload: selectedFunction });

    dispatch(fetchProjectFunctionDetails({ functionId: selectedFunction.id, projectId }));

}

const submitPendingActions = pendingActions => async (dispatch, getState) => {

    let webServices = new WebServices();
    dispatch({ type: ACTIONS_SUBMIT_PENDING, payload: pendingActions });

    try {
        const projectId = getState().actions.selectedProject.id;
        const functionId = getState().actions.selectedProject.selectedFunction.id;

        const updatedPendingActions = await webServices.submitPendingActions(pendingActions);
        const projectFunctionDetails = await webServices.actiontsProjectFunctionDetails({ projectId, functionId });

        dispatch({ type: ACTIONS_SUBMIT_PENDING_SUCCESS, payload: projectFunctionDetails });
        dispatch(showSnackBarMessage(`Pending Changes Submitted Succesfully`));

    } catch (error) {
        dispatch({ type: ACTIONS_SUBMIT_PENDING_ERROR, payload: error });
        dispatch(showSnackBarMessage(`Error Submitting`));

    }

}


const updateApprovedAction = action => ({ type: ACTIONS_UPDATE_APPROVED, payload: action });

const setPendingStepIndex = stepIndex => ({ type: ACTIONS_SET_PENDING_STEP_INDEX, payload: stepIndex });


const deleteDeviationFile = ({ deviationFile, procedureId }) => dispatch => {

    let webServices = new WebServices();
    dispatch({ type: ACTIONS_DELETE_DEVIATION_FILE, payload: deviationFile });

    webServices.deleteDeviationFile(deviationFile.id)
        .then((response) => {

            if (response) {
                dispatch(showSnackBarMessage(`${deviationFile.virtualPath} deleted successfully`));
                dispatch({ type: ACTIONS_DELETE_DEVIATION_FILE_SUCCESS, payload: { deviationFile, procedureId } });
            } else {
                dispatch(showSnackBarMessage(`Failed to delete ${deviationFile.virtualPath}`));
                dispatch({ type: ACTIONS_DELETE_DEVIATION_FILE_ERROR, payload: { deviationFile, procedureId } });
            }


        })
        .catch((error) => {
            dispatch(showSnackBarMessage(`Failed to delete ${deviationFile.virtualPath}`));
            dispatch({ type: ACTIONS_DELETE_DEVIATION_FILE_ERROR, payload: error });
        });
}

const uploadDeviationFiles = (uploadInfo) => (dispatch) => {
    const { files, procedureId } = uploadInfo;
    let webServices = new WebServices();
    dispatch({ type: ACTIONS_UPLOAD_DEVIATION_FILES, payload: { files, procedureId } });

    webServices.uploadDeviationFiles({ files, procedureId })
        .then((files) => {


            dispatch(showSnackBarMessage("Files uploaded Successfully"));
            dispatch({ type: ACTIONS_UPLOAD_DEVIATION_SUCCESS, payload: { files, procedureId } });

        })
        .catch((error) => {
            dispatch(showSnackBarMessage("Files Failed to upload"));

            dispatch({ type: ACTIONS_UPLOAD_DEVIATION_FILES_ERROR, payload: error });
        });

}



const oneTimeDeviation = (deviation, completion = () => { }) => async (dispatch, getState) => {

    let webServices = new WebServices();
    dispatch({ type: ACTIONS_ONE_TIME_DEVIATION, payload: deviation });

    try {
        const deviationResponse = await webServices.oneTimeDeviation(deviation);
        const projectId = getState().actions.selectedProject.id;
        const functionId = getState().actions.selectedProject.selectedFunction.id;
        const projectFunctionDetails = await webServices.actiontsProjectFunctionDetails({ projectId, functionId });
        dispatch({ type: ACTIONS_ONE_TIME_DEVIATION_SUCCESS, payload: projectFunctionDetails });
        completion(true);


    } catch (error) {
        completion(false);
        dispatch({ type: ACTIONS_ONE_TIME_DEVIATION_ERROR, payload: ACTIONS_ONE_TIME_DEVIATION_ERROR });
        dispatch(showSnackBarMessage("One time deviation error"));

    }


}

const updateAction = (action, fieldsToUpdate) => async (dispatch, getState) => {
    let webServices = new WebServices();
    dispatch({ type: ACTION_UPDATE, payload: { procedureId: action.procedureId, fieldsToUpdate } });

    try {

        const updatedAction = await webServices.updateAction({ ...action, ...fieldsToUpdate });

        const projectId = getState().actions.selectedProject.id;
        const functionId = getState().actions.selectedProject.selectedFunction.id;
        const projectFunctionDetails = await webServices.actiontsProjectFunctionDetails({ projectId, functionId });

        dispatch({ type: ACTION_UPDATE_SUCCESS, payload: { updatedAction, projectFunctionDetails } });

        dispatch(showSnackBarMessage("Action Updated"));

    } catch (error) {

        dispatch(showSnackBarMessage("Error Updating Action"));
        dispatch({ type: ACTION_UPDATE_ERROR, payload: { error, procedureId: action.procedureId, fieldsToUpdate } });

    }
}

const updateAllAction = (action) => async (dispatch, getState) => {
    let webServices = new WebServices();
    dispatch({ type: ACTION_UPDATE_ALL });

    try {
        const projectId = getState().actions.selectedProject.id;
        const functionId = getState().actions.selectedProject.selectedFunction.id;
        const updatedAction = await webServices.updateAllAction(projectId, functionId, [...action]);
        const projectFunctionDetails = await webServices.actiontsProjectFunctionDetails({ projectId, functionId });

        dispatch({ type: ACTION_UPDATE_SUCCESS, payload: { updatedAction, projectFunctionDetails } });

        dispatch(showSnackBarMessage("Action Updated"));

    } catch (error) {

        dispatch(showSnackBarMessage("Error Updating Action"));
        dispatch({ type: ACTION_UPDATE_ALL_ERROR, payload: { error } });

    }
}

const submitActions = (pendingActions, approvedActions) => async (dispatch) => {

    let webServices = new WebServices();
    dispatch({ type: ACTIONS_SUBMIT, payload: pendingActions });

    let approvedActionsArray = approvedActions.projectActionGroups.map(projectActionGroup => {

        return projectActionGroup.functions.reduce((actions, aFunction) => [...actions, aFunction.approvedActions], [])

    }).flat(2).filter(action => action.applicabilityId != action.originalApplicabilityId);


    try {
        const actions = await webServices.submitActionsWithApprovedUpdates({ pendingActions: pendingActions, approvedActions: approvedActionsArray })
        dispatch(showSnackBarMessage("Actions Submitted Successfully"));
        dispatch({ type: ACTIONS_SUBMIT_SUCCESS, payload: actions });


    } catch (error) {

        dispatch(showSnackBarMessage("Error Submitting Actions"));
        dispatch({ type: ACTIONS_SUBMIT_ERROR, payload: error });

    }
}

const saveActionProcedureComment = (procedureComment) => async (dispatch, getState) => {

    let webServices = new WebServices();
    dispatch({ type: ACTIONS_PROCEDURE_COMMENT_SAVE });

    try {
        const procedureComments = await webServices.saveActionProcedureComment(procedureComment);
        // dispatch({ type: ACTIONS_PROCEDURE_COMMENT_SAVE_SUCCESS, payload: projectFunctionDetails});

    } catch (error) {
        dispatch({ type: ACTIONS_PROCEDURE_COMMENT_SAVE_ERROR, payload: error });
        dispatch(showSnackBarMessage("Error Saving Procedure Comment"));
    }
}

export { changeCompliance, setPendingSortProperty, setApprovedSortProperty, updateAction, updateAllAction, submitPendingActions, setPendingStepIndex, fetchProjectFunctionDetails, fetchProjectFunctions, updateApprovedAction, fetchActions, submitActions, uploadDeviationFiles, deleteDeviationFile, oneTimeDeviation, selectProject, selectProjectFunction, saveActionProcedureComment };

